// external modules
import { useTranslation } from "react-i18next";
// components
import SubTitle from "../@common/SubTitle/SubTitle";
import Title from "../@common/Title/Title";
import ImageRenderer from "components/@common/ImageRenderer/ImageRenderer";

// styles & types & assets
import shampooCard from "assets/img/@intro/shampoo-card.webp";
import styles from "./Step3.module.scss";

export default function Step3() {
  const { t } = useTranslation();
  return (
    <section className={styles["wrapper-step3"]}>
      <div className={styles["wrap-title"]}>
        <SubTitle>{t("다들 좋다는 샴푸? 나에게 딱 맞는 제품으로!")}</SubTitle>
        <Title>{t("샴푸 랭킹 추천")}</Title>
      </div>
      <div className={styles["wrap-shampoo"]}>
        <ImageRenderer src={shampooCard} alt={"shampooCard"} />
      </div>
    </section>
  );
}
